var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",staticStyle:{"margin":"20px"}},[(_vm.$vuetify.theme.dark)?_c('v-icon',{staticClass:"theme-icon",on:{"click":_vm.toggleTheme}},[_vm._v(" mdi-weather-sunny ")]):_c('v-icon',{staticClass:"theme-icon",on:{"click":_vm.toggleTheme}},[_vm._v(" mdi-weather-night ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }